import firebase from 'firebase/app';
import 'firebase/firestore';
import { generateGUID } from './sharedFunctions';
import { Report } from '../../views';

export const logLogout = async (sessionId, logoutType = 'user logout') => {
    try {
        console.log('[INFO - logLogout] - Logging out sessionId: ' + sessionId);
        const logoutData = {
            logoutid: generateGUID(),
            sessionid: sessionId,
            logoutdatetime: new Date(),
            logouttype: logoutType
        }
        await firebase.firestore().collection('loggingLogout').add(logoutData);
        console.log('[INFO - logLogout] - Logged out sessionId: ' + sessionId);
    } catch (error) {
        console.log('[ERROR - logLogout] - Error occurred Logging out sessionId: ' + sessionId + ', ' + error);
    }
};

export const logSession = async (user, sessionId, loginStatus) => {
    try {
        console.log('[INFO - logSession] - Logging session start: ' + sessionId);

        // Fetch the user document to get their metadata
        const userDoc = await firebase.firestore().collection('users').doc(user.uid).get();
        const userData = userDoc.data();

        // Ade - check the user data
        //console.log(JSON.stringify(userData, null, 2));

        const sessionData = {
            connection: process.env.REACT_APP_ENV,
            logindatetime: new Date(),
            loginstatus: loginStatus,
            sessionid: sessionId,
            user: {
                UID: user.uid,
                Email: user.email,
                metadata: {
                    appid: userData.Metadata.ApplicationID || '',
                    groupid: userData?.Metadata?.GroupID || '',
                    reports: userData?.Metadata?.Reports || [],
                }
            },
        }////
        await firebase.firestore().collection('loggingSession').add(sessionData);
        console.log('[INFO - logSession] - Logged session start: ' + sessionId);

    } catch (error) {
        console.log('[ERROR - logSession] - Error occurred logging session start: ' + sessionId + ', ' + error);
    }
};

export const logReport = async (user, reportData) => {
    try {

        // Fetch the user document to get their metadata
        const userDoc = await firebase.firestore().collection('users').doc(user.uid).get();
        const userData = userDoc.data();

        // Ade - check the report/bookmark values provided
        //console.log(JSON.stringify(reportData, null, 2));

        console.log('[INFO - logReport] - Logging report for userid: ' + user.uid + ', sessionid: ' + user.sessionId + ', reportid: ' + reportData.reportId + ', datasetid: ' + reportData.datasetId);

        const reportInfo = {
            loggingreportid: generateGUID(),
            sessionid: user.sessionId,
            reportid: reportData.reportId,
            reportname: reportData.reportName,
            reportsectionid: reportData.reportSectionId,
            reportsectionname: reportData.reportSectionName,
            datasetid: reportData.datasetId,
            bookmarkid: reportData.bookmarkId,
            bookmarkdisplayname: reportData.bookmarkDisplayName,
            bookmarktype: reportData.bookmarkType,
            reportstartdatetime: new Date(),
        };

        await firebase.firestore().collection('loggingReport').add(reportInfo);
        console.log('[INFO - logReport] - Logged report for userid: ' + user.uid + ', sessionid: ' + user.sessionId + ', reportid: ' + reportData.reportId);

    } catch (error) {
        console.error('[ERROR - logReport] - ', error);
    }
};